module.exports = __webpack_public_path__ + "img/user-pilot.574c230d.svg";